import { useQuery } from 'react-query';

import { apiClient } from '../apiClient';

export const getFilters = async ({ status }: { status?: string }) => {
    const response = await apiClient.post(`property-leads/filters`, {
        json: {
            status,
        },
    });
    return await response.json();
};

export const useGetFiltersQuery = ({
    status,
    ...options
}: {
    status?: string;
}) => {
    return useQuery(
        ['property-leads-filters', { status }],
        async () => await getFilters({ status }),
        {
            ...options,
        }
    );
};
